import React, { Component } from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { ThemeContext } from './components/Core/ThemeContext';
import SEO from './components/SEO';

const privacyPageStyles = {
    page: {
        minHeight: '100vh',
        padding: 'clamp(16px, 3vw, 28px)',
        background: 'linear-gradient(180deg, #f8f8f4 0%, #edf4f3 42%, #f9fbfb 100%)',
    },
    frame: {
        width: 'min(100%, 940px)',
        margin: '0 auto',
    },
    stack: {
        display: 'flex',
        flexDirection: 'column',
        gap: 18,
    },
    heroShell: {
        display: 'flex',
        background: 'linear-gradient(135deg, #fffdfa 0%, #f4faf9 100%)',
        borderRadius: 14,
        overflow: 'hidden',
        border: '1px solid rgba(188, 198, 208, 0.4)',
        boxShadow: '0 14px 32px rgba(86, 96, 110, 0.1)',
    },
    heroStrip: {
        width: 18,
        minWidth: 18,
        background: 'var(--color-grad-1)',
    },
    heroBody: {
        flex: 1,
        padding: 'clamp(18px, 3vw, 26px)',
    },
    heroEyebrow: {
        margin: 0,
        color: 'rgba(90, 105, 108, 0.84)',
        fontSize: '0.74em',
        fontWeight: 700,
        letterSpacing: '0.14em',
        textTransform: 'uppercase',
    },
    heroTitle: {
        margin: '6px 0 0 0',
        fontSize: 'clamp(1.9em, 4vw, 2.45em)',
        color: 'rgba(0, 0, 0, 0.82)',
        fontFamily: 'Dancing Script, Georgia',
        lineHeight: 1.1,
    },
    heroSummary: {
        margin: '12px 0 0 0',
        color: 'rgba(0, 0, 0, 0.7)',
        fontSize: '1em',
        lineHeight: 1.7,
        maxWidth: 720,
    },
    shell: {
        display: 'flex',
        background: '#fff',
        borderRadius: 12,
        overflow: 'hidden',
        boxShadow: '0 12px 28px rgba(86, 96, 110, 0.08)',
        border: '1px solid rgba(188, 198, 208, 0.38)',
    },
    strip: {
        width: 12,
        minWidth: 12,
        background: 'var(--color-grad-1)',
    },
    content: {
        flex: 1,
        background: 'linear-gradient(180deg, #fffefb 0%, #fcfdfd 100%)',
    },
    summaryButton: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        padding: '16px clamp(16px, 2.6vw, 22px)',
        background: 'transparent',
        border: 0,
        cursor: 'pointer',
        textAlign: 'left',
    },
    summaryText: {
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        minWidth: 0,
    },
    summaryEyebrow: {
        margin: 0,
        color: 'rgba(92, 108, 111, 0.82)',
        fontSize: '0.72em',
        fontWeight: 700,
        letterSpacing: '0.12em',
        textTransform: 'uppercase',
    },
    summaryTitle: {
        margin: 0,
        color: 'rgba(0, 0, 0, 0.8)',
        fontSize: '1.05em',
        fontWeight: 700,
        letterSpacing: '0.01em',
    },
    summaryDivider: {
        height: 1,
        background: 'rgba(188, 198, 208, 0.32)',
        margin: '0 clamp(16px, 2.6vw, 22px)',
    },
    summaryBody: {
        padding: '16px clamp(16px, 2.6vw, 22px) 20px clamp(16px, 2.6vw, 22px)',
        color: 'rgba(0, 0, 0, 0.76)',
    },
    collapsedBody: {
        maxHeight: 0,
        overflow: 'hidden',
        paddingTop: 0,
        paddingBottom: 0,
    },
    paragraph: {
        margin: '0 0 14px 0',
        color: 'rgba(0, 0, 0, 0.76)',
        fontSize: '0.98em',
        lineHeight: 1.76,
    },
    paragraphLast: {
        marginBottom: 0,
    },
    link: {
        color: '#1f5f8d',
        wordBreak: 'break-word',
    },
};

function PrivacyHero() {
    return (
        <div style={privacyPageStyles.heroShell}>
            <div style={privacyPageStyles.heroStrip} />
            <div style={privacyPageStyles.heroBody}>
                <p style={privacyPageStyles.heroEyebrow}>Policy</p>
                <h1 style={privacyPageStyles.heroTitle}>Privacy</h1>
                <p style={privacyPageStyles.heroSummary}>
                    How ai-BIBLE handles analytics, chat transcripts, subscriptions,
                    local device storage, and complaints, presented in a clearer
                    structure for web and mobile.
                </p>
            </div>
        </div>
    );
}

function PrivacySection({
    title,
    eyebrow,
    children,
    startsOpen = true,
}) {
    const [open, setOpen] = React.useState(startsOpen);

    return (
        <section style={privacyPageStyles.shell}>
            <div style={privacyPageStyles.strip} aria-hidden="true" />
            <div style={privacyPageStyles.content}>
                <button
                    type="button"
                    onClick={() => setOpen(!open)}
                    aria-expanded={open}
                    style={privacyPageStyles.summaryButton}
                >
                    <span style={privacyPageStyles.summaryText}>
                        <span style={privacyPageStyles.summaryEyebrow}>{eyebrow}</span>
                        <h2 style={privacyPageStyles.summaryTitle}>{title}</h2>
                    </span>
                    <ExpandMoreIcon
                        style={{
                            transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
                            transition: 'transform 140ms ease',
                            color: 'rgba(83, 102, 106, 0.85)',
                        }}
                    />
                </button>
                <div style={privacyPageStyles.summaryDivider} aria-hidden="true" />
                <div
                    aria-hidden={!open}
                    style={{
                        ...privacyPageStyles.summaryBody,
                        ...(open ? null : privacyPageStyles.collapsedBody),
                    }}
                >
                    {children}
                </div>
            </div>
        </section>
    );
}

function PrivacyParagraph({ children, last = false }) {
    return (
        <p
            style={{
                ...privacyPageStyles.paragraph,
                ...(last ? privacyPageStyles.paragraphLast : null),
            }}
        >
            {children}
        </p>
    );
}

class Privacy extends Component {
    static contextType = ThemeContext;

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidMount() {
        this.context.loading(false);
    }

    componentWillUnmount() {
        console.log('Will Unmount');
    }

    render() {
        const title = 'ai-BIBLE Privacy Policy | Analytics, Chat and Data Use';
        const description = 'Read the ai-BIBLE privacy policy covering analytics, chat transcripts, subscriptions, local storage, and data handling.';
        document.title = title;

        return (
            <div style={privacyPageStyles.page}>
                <SEO canonical="https://www.ai-bible.com/privacy" title={title} description={description} />
                <div style={privacyPageStyles.frame}>
                    <div style={privacyPageStyles.stack}>
                        <PrivacyHero />

                        <PrivacySection title="Collection" eyebrow="Data Use">
                            <PrivacyParagraph>
                                ai-BIBLE is published by{' '}
                                <a style={privacyPageStyles.link} href="https://adbc-innovation.com/">
                                    ADBC Innovation Pty Ltd
                                </a>
                                {' '}in Australia and comes under the Australian Privacy Act. The business goal is not to collect people&apos;s personal data; however we need or may encounter a certain amount in the improvement process of ai-BIBLE. For instance, ai-BIBLE uses a cookieliess analytics solution and the chat bot transcripts need to be collected and reviewed periodically.
                            </PrivacyParagraph>
                            <PrivacyParagraph>
                                ai-BIBLE uses a cookieless analytics solution to capture events and basic metrics for understanging usage patterns and levels.
                            </PrivacyParagraph>
                            <PrivacyParagraph>
                                Those basic metrics include users locale (e.g. en_US or uk_UA), users timezone (e.g. Europe/Helsinki), the URL of the previous webpage from which a page was opened, the page user currently views (e.g. /hello), perf - an object which contains performance metrics related to the page load, users IP Address and User Agent.
                            </PrivacyParagraph>
                            <PrivacyParagraph>
                                When subscribing to devotionals or newsletters or sending emails then your email address will be stored.
                            </PrivacyParagraph>
                            <PrivacyParagraph>
                                ai-BIBLE stores transcripts of the chats had with the chat bot, some of those transcripts are received by openai&apos;s chatGPT API also. This is collected to help improve the chat bot, and shared to provide a failover to openai&apos;s chatGPT if the bot cannot answer your question. For this reason we ask that you do not enter identifying information into the chat bot. To contact ai-BIBLE then please use the contact form rather than entering information into the chatbot as long term consideration is being given to adding tools to deliberately strip personally identifying information from chat transcripts.
                            </PrivacyParagraph>
                            <PrivacyParagraph last>
                                The new labs feature in ai-BIBLE uses localStorage to store information that is submitted for the sake of the operation of the labs feature. This information is essential for operation of the feature.
                            </PrivacyParagraph>
                        </PrivacySection>

                        <PrivacySection title="Disclosure" eyebrow="Sharing" startsOpen={false}>
                            <PrivacyParagraph>
                                ai-BIBLE only shares queries with third party ai providers (in particular openai&apos;s chatGPT). In the future it could be the case that other 3rd parties are consulted to assist with product improvement, product ownership or review of the product. In theory investors or governing bodies may need to review some of the analytics information and potentially see some transcripts, and it may be that broad trends are used in public communications. The information collection by ai-BIBLE is stored on 3rd party servers (AWS / Google), see the section on storage for that.
                            </PrivacyParagraph>
                            <PrivacyParagraph>
                                ai-BIBLE does share queries with openai that are unidentified as long as PII information is not included in the text queries sent to the bot.
                            </PrivacyParagraph>
                            <PrivacyParagraph last>
                                Information added to localStorage in the app is not shared.
                            </PrivacyParagraph>
                        </PrivacySection>

                        <PrivacySection title="Storage" eyebrow="Retention" startsOpen={false}>
                            <PrivacyParagraph>
                                Any information collected in the labs section of the app is only stored on your local device and not online.
                            </PrivacyParagraph>
                            <PrivacyParagraph last>
                                Any information collected is stored in cloud solutions such as Amazon Web Services or Google Cloud Platform, with the exception of direct emails that are stored in email accounts. The information is stored in protected accounts. Unidentified sentences in transcripts are held indefinitely, email addresses for devotionals are deleted once the devotional is complete, email addresses for newsletters are kept until unsubscribed and unverified email addresses remain in the database until verified. The analytics solution deletes information after 26 months, this is subject to change as I would like to reduce this.
                            </PrivacyParagraph>
                        </PrivacySection>

                        <PrivacySection title="Modification" eyebrow="Controls" startsOpen={false}>
                            <PrivacyParagraph>
                                Information in the labs section of the app can be modified using the tool used to add the data in the first place. If you would like to delete the data then the manage data tool in the labs section will do that for you.
                            </PrivacyParagraph>
                            <PrivacyParagraph>
                                All information is de-identified (except for email addresses for subscriptions and direct contact) and so it may not be possible to modify the data. You can use the google analytics opt out tool to avoid being tracked by this site:
                            </PrivacyParagraph>
                            <PrivacyParagraph>
                                <a style={privacyPageStyles.link} href="https://tools.google.com/dlpage/gaoptout">
                                    https://tools.google.com/dlpage/gaoptout
                                </a>
                            </PrivacyParagraph>
                            <PrivacyParagraph last>
                                If you have accidentally disclosed personal information to the chat bot then use the contact form on this website and request it is deleted. Because the information is not identified then please provide something you typed in, or a date that you entered the information. Please do get in touch if any information is incorrectly entered or you have any concerns.
                            </PrivacyParagraph>
                        </PrivacySection>

                        <PrivacySection title="Complaints" eyebrow="Contact" startsOpen={false}>
                            <PrivacyParagraph>
                                ai-BIBLE is run by ADBC Innovation Pty Ltd and comes under the Australian Privacy Act. It is preferred that complaints can be resolved by contacting ADBC Innovation Pty Ltd. You can get in contact with Alistair de Blacquiere-Clarkson at:
                            </PrivacyParagraph>
                            <PrivacyParagraph>
                                <a style={privacyPageStyles.link} href="https://www.ai-bible.com/contact">
                                    https://www.ai-bible.com/contact
                                </a>
                            </PrivacyParagraph>
                            <PrivacyParagraph>
                                You are free also to make a complaint to the information commissioner:
                            </PrivacyParagraph>
                            <PrivacyParagraph last>
                                <a style={privacyPageStyles.link} href="https://www.oaic.gov.au/privacy/privacy-complaints">
                                    https://www.oaic.gov.au/privacy/privacy-complaints
                                </a>
                            </PrivacyParagraph>
                        </PrivacySection>
                    </div>
                </div>
            </div>
        );
    }
}

export default Privacy;
